// 'use strict';

var AudioSample = require('./AudioSample.js');


var remap = THREE.Math.mapLinear;
var clamp = THREE.Math.clamp;

module.exports = function( options ){

  options = options || {};

  var frame = options.frame || new THREE.Object3D();

  var ctx = Tone.context;

  // Blop.mp3
  // Computer Error.mp3
  // glass_ping.mp3
  // male_cough.mp3
  // most_annoying_sound_ever.mp3
  // popCork.mp3
  // Tick.mp3
  var popSound = new AudioSample('assets/Blop.mp3');

  var limiter = new Tone.Limiter(0).toMaster();

  var gain = new Tone.Volume( 0 ).connect( limiter );
  gain.set( 'volume',  -20 );

  // var effect = new Tone.Chorus(9, 10, 0.5);
  var effect = new Tone.FeedbackDelay("4n", 0.125)

  effect.connect(gain);
  var threshold = 20;

  return {
    gain: gain,

    play: function(sourceObject){

      var source = popSound.play();

      let delta = frame.position.distanceTo(sourceObject.position);

      delta = THREE.Math.mapLinear(delta, 0, 175, 1.25, 0);

      

      if( source.detune ){
        source.detune.value = THREE.Math.randFloat(-3000, 0 );
      } else {
        source.playbackRate.value = THREE.Math.randFloat(0.1, 0.6 )
      }



      var g = ctx.createGain();
      source.connect(g);

      g.gain.value = Math.pow(clamp(delta, 0, 1), 2);
      g.connect(gain, 0, 0);

    }
  }

}